import { FC } from "react";
import cx from 'classnames';
import Styles from './index.module.scss';
import { pagePathUrl } from "@/constants/url";
import { ArticalCoverEnum, IThreadLisItem } from "@/api/thread/list";
import { formatDisplayNumber } from "@/utils/formatNumber";
import ViewIcon from '../../../../assets/icon/feed/view.svg';
import CommonImage, { ImageType } from "@/components/CommonImage";

const ActivityCard: FC<IThreadLisItem> = (props: IThreadLisItem) => {

  const {
    tid,
    covers = [],
    views,
    subject,
    summary
  } = props;

  const handleGotoDetail = (e: any) => {
    e.stopPropagation();
    if (tid) {
      window.open(`${pagePathUrl.detail}?tid=${tid}`);
    }
  };

  return (
    <div className={Styles.activityCard} onClick={handleGotoDetail}>
      {!!covers.length ? (
        <div className={cx(Styles.activityImage, covers[0].type  === ArticalCoverEnum.image ? '' : Styles.play)}>
          <CommonImage
            layout="fill"
            cutMode="cover"
            draggable={false}
            src={covers[0].medium as string}
            type={ImageType.image}
          />
        </div>
      ) : <div className={Styles.fallbackStyle}/>}
      <div className={Styles.activityTitle}>{subject}</div>
      <div className={Styles.split}/>
      <div className={Styles.activityDesc}>{summary}</div>
      <div className={Styles.activityFooter}>
        <div className={Styles.view}>
          <div style={{ width: '18px', height: '18px' }}>
            <ViewIcon />
          </div>
          <span>{formatDisplayNumber(views)}</span>
        </div>
        <div className={Styles.activityButton}>查看详情</div>
      </div>
    </div>
  )
}

export default ActivityCard;
